import React, { Component } from "react";
import { Navigate } from "react-router-dom";
import { withRouter } from '../../common/with-router';
import {Card, Form, Button, Row, Col, Table, Dropdown} from "react-bootstrap";
import { FaRegEdit, FaSearch, FaFilter, FaFileExport, FaPlus } from "react-icons/fa";
import api from "../../services/api";
import { hasPerm, formataDataHoraExibicao, getCurrentUser    } from '../../common/utils';
import AsyncSelect from 'react-select/async';
import Paginacao from '../../common/pagination';

class Usuarios extends Component {
    constructor(props) {
        super(props);
        this.onChangeBusca = this.onChangeBusca.bind(this);
        this.onClickPagina = this.onClickPagina.bind(this);
        this.buscaUsuario = this.buscaUsuario.bind(this);

        this.state = {
            listResults: [],
            error: "",
            nome: "",
            sobrenome: "",
            usuario: "",
            email: "",
            status: "",
            super_usuario: "",
            funcionario: "",
            page_numb: 1,
            grupo_id: "",
            grupo_nome: "",
            loading: true,
        };
    }

    componentDidMount(){
        const dados_usuario = getCurrentUser();

        if(!dados_usuario.is_superuser) {
            window.location.href = '/sem-permissao';
            return;
        }

        this.consultaUsuarios(this.state.busca, this.state.page_numb)
    }

    carregaGrupos = async (inputValue) => {
        try {
            const response = await api.get(`/grupos/?busca=${inputValue}`);
            const opcoes = [
                { value: '', label: 'Todos' },
                ...response.data.results.map(grupo => ({
                    value: grupo.id,
                    label: grupo.name
                }))
            ];
            return opcoes;
        } catch (error) {
            console.error('Erro ao carregar grupos:', error);
            return [];
        }
    };

    consultaUsuarios(page_numb=1){
        let url = `/usuarios/?page=${page_numb}`;

        if(this.state.nome){
            url += `&nome=${this.state.nome}`;
        }

        if(this.state.sobrenome){
            url += `&sobrenome=${this.state.sobrenome}`;
        }

        if(this.state.email){
            url += `&email=${this.state.email}`;
        }

        if(this.state.usuario){
            url += `&usuario=${this.state.usuario}`;
        }

        if(this.state.status){
            url += `&status_usuario=${this.state.status}`;
        }
        
        if(this.state.super_usuario){
            url += `&super_usuario=${this.state.super_usuario}`;
        }

        if(this.state.funcionario){
            url += `&funcionario=${this.state.funcionario}`;
        }

        if(this.state.grupo_id){
            url += `&grupo_id=${this.state.grupo_id}`;
        }
        
        api.get(url)
        .then(response => {
            this.setState({
                loading: false,
                error: "",
                listResults: response.data
            });
        })
        .catch(error => {
            let erro_msg = 'Erro ao consultar usuários, tente novamente.';

            if(error.response.status === 500){
                erro_msg = 'Servidor indisponível no momento';
            }
            else if(error.response.status === 403){
                erro_msg = 'Você não tem permissão acessar essa área';
            }

            this.setState({
                loading: false,
                error: erro_msg
            });
        });
    }

    renderRows = () => {
        if('results' in this.state.listResults && this.state.listResults.results.length > 0){
            return this.state.listResults.results.map((item) =>
            <tr key={item.id}>
                <td>{item.id}</td>
                <td>{item.first_name} {item.last_name}</td>                
                <td>{item.email}</td>
                <td>{item.username}</td>
                <td>{(item.is_active) ? 'Sim' : 'Não'}</td>
                <td>{(item.is_staff) ? 'Sim' : 'Não'}</td>
                <td>{(item.is_superuser) ? 'Sim' : 'Não'}</td>
                <td>{formataDataHoraExibicao(item.last_login)}</td>
                <td>
                    <Button variant="outline-secondary" href={"/usuarios/edit/"+item.id} size="sm">
                        <FaRegEdit />
                    </Button>    
                </td>
            </tr>
            );
        }        

        return (
            <tr>
                <td colSpan={7}>Nenhum usuário cadastrado</td>
            </tr>
        );
    };

    onChangeBusca(e, fieldName) {
        if(fieldName === 'grupo_id'){
            this.setState({
                grupo_id: e.value,
                grupo_nome: e.label
            });
        }
        else{
            this.setState({
                [e.target.name]: e.target.value
            });
        }
    }

    onClickPagina(num_page) {
        this.setState({
            loading: true,
            page_numb: num_page
        });
        
        this.consultaUsuarios(num_page)
    };

    buscaUsuario(e) {
        e.preventDefault();

        this.setState({
            loading: true,
        });
        
        this.consultaUsuarios(this.state.busca)
    };

    render() {
        if (!hasPerm('view_user')) {
            return <Navigate to='/sem-permissao' />
        }

        const dados_usuario = getCurrentUser();
        
        if(!dados_usuario.is_superuser) {
            return;
        }

        return (
            <div>
                <Row className="align-items-center">
                    <Col sm={6} lg={6}>
                        <h4 className="page-title">Usuários do Sistema</h4>
                    </Col>
                    <Col sm={6} lg={6} className="text-end">
                        <Button variant="secondary" href="/usuarios/add" className="mb-3" size="sm">
                            <FaPlus /> Adicionar Usuário
                        </Button>
                    </Col>
                </Row>
                <Card className="cardDestaque">
                    <Card.Body>                    
                        <Row>
                            <Col sm={12} lg={12} className="mb-3 d-flex justify-content-end">
                                <Dropdown className="d-inline">
                                    <Dropdown.Toggle variant="outline-secondary" size="sm">
                                        <FaFilter /> Filtrar
                                    </Dropdown.Toggle>

                                    <Dropdown.Menu>
                                        <div className="drop-filter">
                                            <Form method="get" onSubmit={this.buscaUsuario}>
                                                <Row>
                                                    <Col sm={12} xs={12}>
                                                        <Form.Group className="mb-3">
                                                            <Form.Label>Nome</Form.Label>                                  
                                                            <Form.Control
                                                                type="text"
                                                                name="nome"
                                                                value={this.state.nome}
                                                                onChange={this.onChangeBusca}
                                                                placeholder="Nome do usuário"
                                                                aria-label="Nome do usuário"
                                                                aria-describedby="basic-addon2"
                                                            />
                                                        </Form.Group>
                                                    </Col>
                                                    <Col sm={12} xs={12}>
                                                        <Form.Group className="mb-3">
                                                            <Form.Label>Sobrenome</Form.Label>                                  
                                                            <Form.Control
                                                                type="text"
                                                                name="sobrenome"
                                                                value={this.state.sobrenome}
                                                                onChange={this.onChangeBusca}
                                                                placeholder="Sobrenome do usuário"
                                                                aria-label="Sobrenome do usuário"
                                                            />
                                                        </Form.Group>
                                                    </Col>

                                                    <Col sm={12} xs={12}>
                                                        <Form.Group className="mb-3">
                                                            <Form.Label>Usuário</Form.Label>                                  
                                                            <Form.Control
                                                                type="text"
                                                                name="usuario"
                                                                value={this.state.usuario}
                                                                onChange={this.onChangeBusca}
                                                                placeholder="Nome de usuário"
                                                                aria-label="Nome de usuário"
                                                            />
                                                        </Form.Group>
                                                    </Col>

                                                    <Col sm={12} xs={12}>
                                                        <Form.Group className="mb-3">
                                                            <Form.Label>E-mail</Form.Label>                                  
                                                            <Form.Control
                                                                type="email"
                                                                name="email"
                                                                value={this.state.email}
                                                                onChange={this.onChangeBusca}
                                                                placeholder="E-mail do usuário"
                                                                aria-label="E-mail do usuário"
                                                            />
                                                        </Form.Group>
                                                    </Col>

                                                    <Col sm={12} xs={12}>
                                                        <Form.Group className="mb-3">
                                                            <Form.Label>Status</Form.Label>
                                                            <Form.Select className="form-control"
                                                                name="status"
                                                                value={this.state.status}
                                                                onChange={this.onChangeBusca}
                                                            >
                                                                <option value="">Todos</option>
                                                                <option value="True">Ativo</option>
                                                                <option value="False">Inativo</option>
                                                            </Form.Select>
                                                        </Form.Group>
                                                    </Col>

                                                    <Col sm={12} xs={12}>
                                                        <Form.Group className="mb-3">
                                                            <Form.Label>Superusuário</Form.Label>
                                                            <Form.Select className="form-control"
                                                                name="super_usuario"
                                                                value={this.state.super_usuario}
                                                                onChange={this.onChangeBusca}
                                                            >
                                                                <option value="">Todos</option>
                                                                <option value="True">Sim</option>
                                                                <option value="False">Não</option>
                                                            </Form.Select>
                                                        </Form.Group>
                                                    </Col>

                                                    <Col sm={12} xs={12}>
                                                        <Form.Group className="mb-3">
                                                            <Form.Label>Funcionário</Form.Label>
                                                            <Form.Select className="form-control"
                                                                name="funcionario"
                                                                value={this.state.funcionario}
                                                                onChange={this.onChangeBusca}
                                                            >
                                                                <option value="">Todos</option>
                                                                <option value="True">Sim</option>
                                                                <option value="False">Não</option>
                                                            </Form.Select>
                                                        </Form.Group>
                                                    </Col>

                                                    <Col sm={12} xs={12}>
                                                        <Form.Group className="mb-3">
                                                            <Form.Label>Grupo</Form.Label>
                                                            <AsyncSelect className="form-control"
                                                                cacheOptions
                                                                loadOptions={this.carregaGrupos}
                                                                defaultOptions
                                                                name="grupo_id"
                                                                placeholder='Selecionar grupo'
                                                                noOptionsMessage={() => "Nenhum resultado encontrado"}
                                                                onChange={e => this.onChangeBusca(e, 'grupo_id')}
                                                                value={this.state.grupo_id ? { value: this.state.grupo_id, label: this.state.grupo_nome } : null}

                                                            />
                                                        </Form.Group>
                                                    </Col>
                                                </Row>

                                                <Button type="submit" variant="outline-secondary" size="sm">
                                                    <FaSearch /> Filtrar
                                                </Button>
                                            </Form>
                                        </div>
                                    </Dropdown.Menu>
                                </Dropdown>

                                <Button variant="outline-secondary" className="ms-2" size="sm">
                                    <FaFileExport /> Exportar
                                </Button>
                            </Col>
                        </Row>    

                        <Table responsive className="custom-table">
                            <thead>
                                <tr>
                                    <th>ID</th>
                                    <th>Nome</th>                                    
                                    <th>E-mail</th>
                                    <th>Username</th>
                                    <th>Ativo</th>
                                    <th>Colaborador</th>
                                    <th>Superusuário</th>
                                    <th>Último login</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                {this.state.loading ? (
                                <tr>
                                    <td colSpan={7}>Carregando...</td>
                                </tr>
                                ) : (
                                    this.state.error ? (
                                        <tr>
                                            <td colSpan={7}>{this.state.error}</td>
                                        </tr>
                                    ) : this.renderRows()
                                )}                                                       
                            </tbody>
                        </Table>       
                        { 
                            'results' in this.state.listResults && this.state.listResults.results.length > 0 && 
                            <Paginacao dados={this.state.listResults} loading={this.state.loading} page_numb={this.state.page_numb} _onClickPagina={this.onClickPagina} />
                        }                    
                    </Card.Body>                
                </Card>
            </div>
        );
    }
}

export default withRouter(Usuarios);